module.exports = __webpack_public_path__ + "img/mch-main-lsh.816301cb.png";